// Admin sign-in state: the token lives where the rest of the app expects it
// (AUTHORIZATION_TOKEN + ROLE_USER in localStorage) so old and new admin pages agree.
import { setRoleUser, setUser } from '../../redux/actions/user'
import { setUserRoleStorage, updateToken } from '../../utils/auth'
import { ROLES } from '../../utils/constants'

export const SESSION_ENDED_MESSAGE = 'Your admin session ended, please sign in again.'

const EMAIL_KEY = 'MORSEL_ADMIN_EMAIL'
const MESSAGE_KEY = 'MORSEL_ADMIN_MESSAGE'

const safe = (fn, fallback = null) => {
  try {
    return fn()
  } catch (e) {
    return fallback
  }
}

export const getAdminEmail = () => safe(() => window.localStorage.getItem(EMAIL_KEY))

export const startAdminSession = (dispatch, token, email) => {
  updateToken(token)
  setUserRoleStorage(ROLES.ROLE_ADMIN_USER)
  safe(() => window.localStorage.setItem(EMAIL_KEY, email || ''))
  dispatch(setUser(null))
  dispatch(setRoleUser(ROLES.ROLE_ADMIN_USER))
}

export const endAdminSession = (dispatch, message = '') => {
  updateToken()
  setUserRoleStorage(ROLES.ROLE_GUEST)
  safe(() => window.localStorage.removeItem(EMAIL_KEY))
  if (message) safe(() => window.sessionStorage.setItem(MESSAGE_KEY, message))
  dispatch(setUser(null))
  dispatch(setRoleUser(ROLES.ROLE_GUEST))
}

// Read once by the sign-in page
export const takeSessionMessage = () =>
  safe(() => {
    const message = window.sessionStorage.getItem(MESSAGE_KEY)
    window.sessionStorage.removeItem(MESSAGE_KEY)
    return message
  })
